import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { jsonHeaders } from '#lib/helpers/fetch.js';

async function fetchConnections(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/connections`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

export function useConnections() {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['connections'],
        queryFn: fetchConnections,
        staleTime: Infinity,
        keepPreviousData: true
    });

    return {
        data: data?.results,
        ...queryProps
    };
}
